import NumberFormats from './NumberFormats';

export default NumberFormats;
